export const en = {
  landingPageForCompanies: {
    hero: {
      structure: "heading_text",
      text: "Teams Volunteer Together"
    },
    hero_desc:
      'The engagement platform to connect, inspire, and retain extraordinary employees. Live your company’s values and do good with Purposely.',
    book_a_demo: 'Book a demo',
    company_logos_desc:
      'Trusted by teams with a dedication for employee happiness',
    summary_desc: 'The most impactful team building platform, period.',
    summary_list_item_a: 'Volunteer with nonprofits across the world',
    summary_list_item_b: 'Find opportunities for any team size',
    summary_list_item_c: 'Track your company’s impact',
    summary_list_item_d: 'Effortless coordination with nonprofits',
    volunteer_effortlessly: 'Volunteer Effortlessly',
    features: {
      volunteer: {
        title: "Volunteer Effortlessly",
        description: "Software to find opportunities and volunteer with ease",
        bullets: [
          "Find volunteer opportunities anywhere in the world. Really!",
          "We handle coordination so employees can \"just show up\"",
          "Automated reminders keeps everyone on track"
        ]
      },
      track: {
        title: "Track Impact",
        description: "Know how much you and your team have given back",
        bullets: [
          "Get insight into your employees volunteering interests",
          "Track hours and celebrate your achievements",
          "Experience all those warm and fuzzy feelings"
        ]
      },
      difference: {
        title: "Make a Difference Together",
        description: "Share the next \"give back\" with your team",
        bullets: [
          "Automated Slack messages for new opportunities",
          "One click sharing links with all of the details you need",
          "Inspire others with easy social media sharing"
        ]
      }
    },
    blogSection: {
      title: 'Explore our blog',
      viewMore: 'View more',
      subtext: 'Visit our blog for nonprofit resources',
    },
    community: {
      title: "Join an impactful community",
      subtitle: "Purposely is a network full of champions, like you",
      perks: {
        connect: {
          alt: "Heart icon inside a yellow rounded square",
          text: "Connect with people and culture leaders"
        },
        learn: {
          alt: "Person icon inside a yellow rounded square",
          text: "Learn from nonprofit industry experts"
        },
        engage: {
          alt: "Location pin icon inside a yellow rounded square",
          text: "Engage in impactful workshops"
        }
      },
      badge: {
        alt: "Community badge"
      }
    },
    whyVolunteering: {
      title: "Why volunteering matters for your company",
      description: "Beyond being a great community contribution, volunteering is a smart investment. Everyone benefits from the great feeling you get after giving back to the community you love.",
      stats: {
        engagement: {
          stat: "2x",
          title: "Engagement",
          description: "Employee volunteers are twice as likely to report higher fulfillment with their career progression and corporate culture"
        },
        retention: {
          stat: "1.5x",
          title: "Retention",
          description: "Volunteers are 1.5x more likely to stay at their job for the next two years"
        },
        satisfaction: {
          stat: "87%",
          title: "Satisfaction",
          description: "87% of employee volunteers reported greater pride in their company"
        },
        customers: {
          stat: "77%",
          title: "Customers",
          description: "77% of consumers are motivated to buy from companies with a committment to a social impact"
        }
      }
    }
  },
}
